import { detailedDiff } from 'deep-object-diff';
import { flatten } from 'flat';
import { isNull } from 'lodash';
import { IMappedRevision, IRevision } from 'models';

import { humanizeKey } from './mapRevision';

export function formatDiffs(revisions?: IRevision[]): IMappedRevision[] {
	const arr = [];
	if (!Array.isArray(revisions)) {return [];}
	const fullRev = [...revisions, emptyData];

	for (let i = 0; i < fullRev.length - 1; i++) {
		const current = fullRev[i];
		let newer: object = {};
		let older: object = {};

		try {
			newer = flatten(JSON.parse(getSnapshot(current))) as object;
		} catch (e) {
			// eslint-disable-next-line no-console
			console.warn('Invalid snapshot (newer):', getSnapshot(current));
		}

		try {
			older = flatten(JSON.parse(getSnapshot(fullRev[i+1]))) as object;
		} catch (e) {
			// eslint-disable-next-line no-console
			console.warn('Invalid snapshot (older):', getSnapshot(fullRev[i+1]));
		}

		const changes = detailedDiff(older, newer);

		if(changes) {
			arr.push({
				author: current.author,
				date: current.date,
				id: current.id,
				added: mapChanges(changes.added),
				updated: mapChanges(changes.updated),
				deleted: mapChanges(changes.deleted)
			});
		}
	}
	return arr;
}

const emptyData: IRevision = {
	id: 0,
	date: '',
	author: 0,
	acf: {
		snapshot: JSON.stringify({
			acf: {
				date: undefined,
				date_string: undefined,
				state: undefined,
				watched: undefined,
				paid: undefined,
				deposit: undefined,
				charge_id: undefined,
				followups: null,
				foreman_info: {
					status: 'pending',
					workers: false,
					truck: [],
					workers_count: 0,
					loading_time: null,
					loading_flights: '',
					drive_time: null,
					double_drive: false,
					unloading_time: null,
					unloading_flights_: '',
					total_time: '',
					heavy_items: false,
					add_items: false,
					truck_fee: false,
					driving_time_fee: false,
					driving_time_price: '',
					payment: false,
					discount: '',
					tips: '',
					total: '',
					notes: ''
				},
				customer_info: {
					bedroom: '',
					truck: '',
					movers: '',
					time: '',
					payment: '',
					typeofresidency: '',
					packing: '',
					supplies: '',
					small_boxes: '',
					medium_boxes: '',
					wrapping_paper: '',
					howfrom: '',
					heavyItems: '',
					pickup_address: false,
					dropoff_address: false,
					customer_name: '',
					customer_phone: '',
					customer_email: '',
					contact_name: '',
					contact_email: '',
					contact_phone: '',
					note: '',
					truck_fee: '',
					result: ''
				}
			}
		}),
		work_id: ''
	}
};

export function mapChanges(obj: object) {
	return Object.entries(obj).map(([key, value]) => ({
		label: humanizeKey(key),
		value
	})).filter(el => !(el.value === undefined || el.value === 0 || el.value === '0' || el.value === false || el.value === '' || isNull(el.value)));
}

function getSnapshot(revision: IRevision): string {
	return revision?.meta?.snapshot      // новые (post_meta)
    ?? revision?.acf?.snapshot         // старые (ACF)
    ?? '{}';
}